module.exports = __webpack_public_path__ + "static/media/CommsBadge.d64ddd67.png";